/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, ButtonGroup, ToggleButton, Image } from 'react-bootstrap';

import { Titre, Item } from '../Fonctions';

// Modèles
const lames = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/StoreVision_Lames.webp?alt=media&token=ddb28c48-b735-47a6-b9a6-fe135c4231a9";
const blackout = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/StoreVision_Blackout.webp?alt=media&token=a4cf9cab-e410-4807-a261-6ff1c76a1ec8";

function Store({ store_type, setStore }) {
	const debug = false;

	return (
		<Stack gap={2}>
			<Titre>Modèle</Titre>
			<ButtonGroup style={{ width: '95%' }}>
				<ToggleButton
					style={{ width: '100%'}}
					id='lames'
					type="radio"
					variant={'outline-dark'}
					name="lames"
					checked={store_type === 0}
					onClick={(e) => setStore(0)}>
					<Stack gap={2}>
						<Item>StoreVision Lames</Item>
						Store vénitien à lames relevables et orientables
						<Image src={lames} rounded style={{ width: '80%', display: 'block', margin: 'auto' }} alt='lames-img'/>
					</Stack>
				</ToggleButton>
				<ToggleButton
					style={{ width: '100%'}}
					id='blackout'
					type="radio"
					variant={'outline-dark'}
					name="blackout"
					checked={store_type === 1}
					onClick={(e) => setStore(1)}>
					<Stack gap={2}>
						<Item>StoreVision Blackout</Item>
						Store en tissu plissé offrant le noir intégral, même en plein jour
						<Image src={blackout} rounded style={{ width: '80%', display: 'block', margin: 'auto' }} alt='blackout-img'/>
					</Stack>
				</ToggleButton>
			</ButtonGroup>
			{debug ? store_type : null}
		</Stack>
	);
}

export default Store;
